import ContactFormProvider, {
  ContactForm,
} from 'components/contact/ContactForm';
import ContactHelmet from 'components/contact/ContactHelmet';
import ContactSubmitButton from 'components/contact/ContactSubmitButton';
import Link from 'next/link';
import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import styled from 'styled-components';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useViewContext } from 'providers/ViewContextProvider';
import ArrowRightIcon from '@seaweb/coral/components/icons/ArrowRight';

const ContactPageWrapper = styled.div`
  background-image: ${(props) =>
    !props.isMobileView
      ? `url('/images/st-pic.svg'), url('/images/st-message.svg'), url('/images/st-chat.svg')`
      : 'unset'};
  background-position: left 50px center, top 50px right 30px,
    bottom 50px right 30px;
  background-repeat: no-repeat, no-repeat, no-repeat;
  margin: auto;
  padding: 0 20px 40px;
`;

const InnerPage = styled.div`
  margin: 50px auto;
  width: 100%;
  max-width: 1160px;
`;

const NavSection = styled.div`
  margin: 0 0 40px;
  display: flex;
  align-items: center;
`;

const StyledArrow = styled(ArrowRightIcon)`
  opacity: 0.6;
`;

const SearchLink = styled.a`
  font-size: 14px;
  color: #1b92f5;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: rgba(27, 146, 245, 0.05);
  }

  &:active {
    background-color: rgba(27, 146, 245, 0.1);
  }
`;

const LastSearchLink = styled.div`
  font-size: 14px;
  color: #202325;
  padding: 2px 8px;
`;

export const FormActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

function ContactButton() {
  return typeof window !== `undefined` ? (
    (() => {
      const ContactSubmitClient =
        // using require to support SSR of Coral Pusher
        // eslint-disable-next-line global-require
        require('components/contact/ContactSubmitClient').default;
      return <ContactSubmitClient />;
    })()
  ) : (
    <ContactSubmitButton />
  );
}

function ContactPage() {
  const { locale: t } = useLocaleContext();
  const { isMobileView } = useViewContext();

  return (
    <ContactPageWrapper isMobileView={isMobileView}>
      <ContactHelmet />

      <InnerPage>
        {!isMobileView && (
          <NavSection>
            <Link href="/">
              <SearchLink>{t('hc.help_center')}</SearchLink>
            </Link>
            <StyledArrow />
            <LastSearchLink>{t('hc.contact.contact_us')}</LastSearchLink>
          </NavSection>
        )}

        <GoogleReCaptchaProvider reCaptchaKey="6Levg7IZAAAAANLEnRbRIOMTf1OHqeOnzgcrorxO">
          <ContactFormProvider>
            <ContactForm />
            <ContactButton />
          </ContactFormProvider>
        </GoogleReCaptchaProvider>
      </InnerPage>
    </ContactPageWrapper>
  );
}

export default ContactPage;
